var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#438afe;}.a{stroke:#707070;opacity:0;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-333 -306)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(333 306)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(333 214.997)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.499 97.065)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M90.094,127.881c-.471-.982-2.156-2.345-3.784-3.662-.908-.734-1.766-1.428-2.313-1.975a.5.5,0,0,0-.523-.117c-.337.122-.545.216-.709.289a1.654,1.654,0,0,1-.671.184.5.5,0,0,0-.366.219,1.529,1.529,0,0,1-1.928.8c-.156-.052-.184-.119-.2-.183a3.306,3.306,0,0,1,1.1-2.144c1.625-1.626,2.463-2.033,4.233-1.242,2.008.9,4.02,1.6,4.04,1.608a.5.5,0,1,0,.329-.945c-.02-.007-1.992-.7-3.96-1.577-2.293-1.025-3.551-.35-5.348,1.448-.684.684-1.613,2.068-1.373,3.083a1.237,1.237,0,0,0,.859.9,2.5,2.5,0,0,0,2.937-1.006,2.524,2.524,0,0,0,.751-.238c.094-.042.2-.091.35-.15.572.537,1.344,1.162,2.157,1.819,1.47,1.189,3.137,2.537,3.512,3.317a.586.586,0,0,1-.149.751.551.551,0,0,1-.616.121.5.5,0,0,0-.781.465.6.6,0,0,1-.383.563.767.767,0,0,1-.779.018.5.5,0,0,0-.839.319.95.95,0,0,1-.59.766.527.527,0,0,1-.574-.089.506.506,0,0,0-.457-.116.5.5,0,0,0-.351.315c-.019.05-.062.17-.53.17a2.879,2.879,0,0,1-1.225-.419c-.351-.231-2.552-1.873-4.453-3.465-.267-.225-.729-.707-1.137-1.133-.362-.378-.693-.721-.863-.865a.5.5,0,0,0-.646.764c.155.131.455.448.786.793.446.466.907.948,1.217,1.208,1.862,1.559,4.1,3.242,4.546,3.535a3.836,3.836,0,0,0,1.775.582,1.721,1.721,0,0,0,1.135-.334,1.556,1.556,0,0,0,1.137-.012,1.97,1.97,0,0,0,1.041-.961,1.934,1.934,0,0,0,1.255-.181,1.7,1.7,0,0,0,.835-.872,1.635,1.635,0,0,0,1.147-.411A1.59,1.59,0,0,0,90.094,127.881Z",
    transform: "translate(-74.642 -118.658)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 98.003)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M111.666,138.663h-4.5a.5.5,0,0,0,0,1h4.5a.5.5,0,0,0,0-1Z",
    transform: "translate(-106.666 -138.663)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.038 105.002)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M387.188,288.2a.5.5,0,0,0-.694-.136l-1.462.982a.5.5,0,0,0,.558.83l1.462-.982A.5.5,0,0,0,387.188,288.2Z",
    transform: "translate(-384.811 -287.977)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.501 104.503)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M291.826,280.425c-.358-.282-1.959-1.921-2.949-2.953a.5.5,0,0,0-.722.692c.257.268,2.524,2.631,3.051,3.047a.5.5,0,0,0,.309.107.505.505,0,0,0,.394-.191A.5.5,0,0,0,291.826,280.425Z",
    transform: "translate(-288.016 -277.317)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 106.004)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M259.318,311.947c-.6-.479-2.1-2.078-2.444-2.448a.5.5,0,1,0-.737.677c.018.019,1.814,1.958,2.556,2.552a.5.5,0,0,0,.625-.781Z",
    transform: "translate(-256.005 -309.337)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 107.002)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M216.666,333.262c-.713-.6-2.172-2.154-2.457-2.459a.5.5,0,0,0-.731.683c.41.439,1.806,1.919,2.543,2.541a.5.5,0,0,0,.645-.765Z",
    transform: "translate(-213.343 -330.644)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 96.003)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.844,97.14C4.987,96.328,1.56,96.065.53,96a.5.5,0,0,0-.53.5v9a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.475-.345A52.424,52.424,0,0,0,6,97.546.5.5,0,0,0,5.844,97.14ZM3.135,105H1V97.039a15.191,15.191,0,0,1,3.971.709A52.466,52.466,0,0,1,3.135,105Z",
    transform: "translate(0 -96.003)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.018 97.003)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M369.529,117.33a15.6,15.6,0,0,0-6.2,1.047.5.5,0,0,0-.267.311.5.5,0,0,0,.055.406,66.477,66.477,0,0,1,2.925,7.869.5.5,0,0,0,.482.367h3a.5.5,0,0,0,.5-.5v-9A.5.5,0,0,0,369.529,117.33Zm-.5,9H366.9c-.474-1.544-1.874-5.57-2.655-7.234a16.285,16.285,0,0,1,4.781-.76Z",
    transform: "translate(-363.046 -117.33)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.6ba6d9bd77c6931ac29876539262efc3.svg";
export { ForwardRef as ReactComponent };